import { linearInterpolation } from './linearInterpolation';
import { ILine } from '../types.DrawIt';

export const lineSimilarity = (actualLine: ILine[], userLine: ILine[], maxValue: number): number => {
    const interpolator = linearInterpolation(userLine, 'year', 'value');
    const interpolatedUserLine = actualLine.map(actualPoint => {
        const userPoint = userLine.find(userPoint => userPoint.year === actualPoint.year);

        if (userPoint) {
            return userPoint;
        } else {
            return {
                year: actualPoint.year,
                value: interpolator({ year: actualPoint.year })
            };
        }
    });

    const averageDifference =
        actualLine.reduce(
            (allDifferences, currentValue, index) =>
                allDifferences + Math.abs(currentValue.value - interpolatedUserLine[index].value) / maxValue,
            0
        ) / actualLine.length;

    const score = Math.round((1 - averageDifference) * 100) / 100;

    return score;
};
